import * as React from "react";
import { forwardRef } from "react";
const SvgOutlineInfo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1.23 0 0 1.23 8.01 5.18)", id: "nXp-HJkGz7VZJhyvNYdZj" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeDasharray: "none",
  strokeLinecap: "round",
  strokeDashoffset: 0,
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  fill: "none",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", transform: " translate(-1.19, -1.33)", d: "M 1.18652 1.33334 L 1.19319 1.33334", strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1.23 0 0 1.23 8.01 8.01)", id: "s8VK51TFjXIeJyWtSDyf4" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "currentColor",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "round",
  strokeDashoffset: 0,
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  fill: "none",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", transform: " translate(-7.19, -7)", d: "M 7.18652 13 C 10.5002 13 13.1865 10.3137 13.1865 7 C 13.1865 3.68629 10.5002 1 7.18652 1 C 3.87281 1 1.18652 3.68629 1.18652 7 C 1.18652 10.3137 3.87281 13 7.18652 13 Z", strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1.23 0 0 1.23 8.01 9.51)", id: "FIjbe-a2CD4qaLy8UZRN2" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "currentColor",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "round",
  strokeDashoffset: 0,
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  fill: "none",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", transform: " translate(-1.19, -2.33)", d: "M 0.52002 1 L 1.18669 1 L 1.18669 3.66667 L 1.85335 3.66667", strokeLinecap: "round" })));
const ForwardRef = forwardRef(SvgOutlineInfo);
export { ForwardRef as ReactComponent };
